module.exports = __webpack_public_path__ + "static/img/logo-tw.ced8cd94.png";